/* tslint:disable */
/* eslint-disable */
/**
 * Incendium AI API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import * as runtime from '../runtime';
import { ApiGenerateInteractionsPayloadToJSON, ApiListOnboardingResponseFromJSON, ApiNewProjectRequestToJSON, ApiSignupAuthPayloadToJSON, ApiSignupAuthResponseFromJSON, ApiSignupRequestToJSON, ApiSimpleOnboardingFromJSON, ApiSimpleOnboardingToJSON, ApiUrlSyncResponseFromJSON, } from '../models';
/**
 *
 */
export class OnboardingServiceApi extends runtime.BaseAPI {
    /**
     */
    onboardingServiceCreateOnboardingRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.projectId === null || requestParameters.projectId === undefined) {
                throw new runtime.RequiredError('projectId', 'Required parameter requestParameters.projectId was null or undefined when calling onboardingServiceCreateOnboarding.');
            }
            const queryParameters = {};
            if (requestParameters.onboardingType !== undefined) {
                queryParameters['onboardingType'] = requestParameters.onboardingType;
            }
            const headerParameters = {};
            const response = yield this.request({
                path: `/services/onboarding/v1/projects/{projectId}`.replace(`{${"projectId"}}`, encodeURIComponent(String(requestParameters.projectId))),
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => ApiSimpleOnboardingFromJSON(jsonValue));
        });
    }
    /**
     */
    onboardingServiceCreateOnboarding(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.onboardingServiceCreateOnboardingRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    onboardingServiceDeleteOnboardingRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.projectId === null || requestParameters.projectId === undefined) {
                throw new runtime.RequiredError('projectId', 'Required parameter requestParameters.projectId was null or undefined when calling onboardingServiceDeleteOnboarding.');
            }
            const queryParameters = {};
            if (requestParameters.onboardingType !== undefined) {
                queryParameters['onboardingType'] = requestParameters.onboardingType;
            }
            const headerParameters = {};
            const response = yield this.request({
                path: `/services/onboarding/v1/projects/{projectId}`.replace(`{${"projectId"}}`, encodeURIComponent(String(requestParameters.projectId))),
                method: 'DELETE',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response);
        });
    }
    /**
     */
    onboardingServiceDeleteOnboarding(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.onboardingServiceDeleteOnboardingRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    onboardingServiceGenerateInteractionsRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.projectId === null || requestParameters.projectId === undefined) {
                throw new runtime.RequiredError('projectId', 'Required parameter requestParameters.projectId was null or undefined when calling onboardingServiceGenerateInteractions.');
            }
            if (requestParameters.payload === null || requestParameters.payload === undefined) {
                throw new runtime.RequiredError('payload', 'Required parameter requestParameters.payload was null or undefined when calling onboardingServiceGenerateInteractions.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            const response = yield this.request({
                path: `/services/onboarding/v1/projects/{projectId}/interactions`.replace(`{${"projectId"}}`, encodeURIComponent(String(requestParameters.projectId))),
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: ApiGenerateInteractionsPayloadToJSON(requestParameters.payload),
            }, initOverrides);
            return new runtime.JSONApiResponse(response);
        });
    }
    /**
     */
    onboardingServiceGenerateInteractions(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.onboardingServiceGenerateInteractionsRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    onboardingServiceListOnboardingRaw(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/services/onboarding/v1/onboarding`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => ApiListOnboardingResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    onboardingServiceListOnboarding(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.onboardingServiceListOnboardingRaw(initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    onboardingServiceNewProjectRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.body === null || requestParameters.body === undefined) {
                throw new runtime.RequiredError('body', 'Required parameter requestParameters.body was null or undefined when calling onboardingServiceNewProject.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            const response = yield this.request({
                path: `/services/onboarding/v1/new-project`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: ApiNewProjectRequestToJSON(requestParameters.body),
            }, initOverrides);
            return new runtime.JSONApiResponse(response);
        });
    }
    /**
     */
    onboardingServiceNewProject(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.onboardingServiceNewProjectRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    onboardingServicePublishOnboardingRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.projectId === null || requestParameters.projectId === undefined) {
                throw new runtime.RequiredError('projectId', 'Required parameter requestParameters.projectId was null or undefined when calling onboardingServicePublishOnboarding.');
            }
            const queryParameters = {};
            if (requestParameters.onboardingType !== undefined) {
                queryParameters['onboardingType'] = requestParameters.onboardingType;
            }
            const headerParameters = {};
            const response = yield this.request({
                path: `/services/onboarding/v1/projects/{projectId}/publish`.replace(`{${"projectId"}}`, encodeURIComponent(String(requestParameters.projectId))),
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => ApiSimpleOnboardingFromJSON(jsonValue));
        });
    }
    /**
     */
    onboardingServicePublishOnboarding(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.onboardingServicePublishOnboardingRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    onboardingServiceReadOnboardingRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.projectId === null || requestParameters.projectId === undefined) {
                throw new runtime.RequiredError('projectId', 'Required parameter requestParameters.projectId was null or undefined when calling onboardingServiceReadOnboarding.');
            }
            const queryParameters = {};
            if (requestParameters.onboardingType !== undefined) {
                queryParameters['onboardingType'] = requestParameters.onboardingType;
            }
            const headerParameters = {};
            const response = yield this.request({
                path: `/services/onboarding/v1/projects/{projectId}`.replace(`{${"projectId"}}`, encodeURIComponent(String(requestParameters.projectId))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => ApiSimpleOnboardingFromJSON(jsonValue));
        });
    }
    /**
     */
    onboardingServiceReadOnboarding(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.onboardingServiceReadOnboardingRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    onboardingServiceSignupRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.body === null || requestParameters.body === undefined) {
                throw new runtime.RequiredError('body', 'Required parameter requestParameters.body was null or undefined when calling onboardingServiceSignup.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            const response = yield this.request({
                path: `/services/onboarding/v1/signup`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: ApiSignupRequestToJSON(requestParameters.body),
            }, initOverrides);
            return new runtime.JSONApiResponse(response);
        });
    }
    /**
     */
    onboardingServiceSignup(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.onboardingServiceSignupRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    onboardingServiceSignupAuthRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.service === null || requestParameters.service === undefined) {
                throw new runtime.RequiredError('service', 'Required parameter requestParameters.service was null or undefined when calling onboardingServiceSignupAuth.');
            }
            if (requestParameters.payload === null || requestParameters.payload === undefined) {
                throw new runtime.RequiredError('payload', 'Required parameter requestParameters.payload was null or undefined when calling onboardingServiceSignupAuth.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            const response = yield this.request({
                path: `/services/onboarding/v1/signup/{service}/auth`.replace(`{${"service"}}`, encodeURIComponent(String(requestParameters.service))),
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: ApiSignupAuthPayloadToJSON(requestParameters.payload),
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => ApiSignupAuthResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    onboardingServiceSignupAuth(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.onboardingServiceSignupAuthRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    onboardingServiceSignupAuthUrlRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.service === null || requestParameters.service === undefined) {
                throw new runtime.RequiredError('service', 'Required parameter requestParameters.service was null or undefined when calling onboardingServiceSignupAuthUrl.');
            }
            const queryParameters = {};
            if (requestParameters.redirectUrl !== undefined) {
                queryParameters['redirectUrl'] = requestParameters.redirectUrl;
            }
            if (requestParameters.state !== undefined) {
                queryParameters['state'] = requestParameters.state;
            }
            if (requestParameters.shop !== undefined) {
                queryParameters['shop'] = requestParameters.shop;
            }
            const headerParameters = {};
            const response = yield this.request({
                path: `/services/onboarding/v1/signup/{service}/url`.replace(`{${"service"}}`, encodeURIComponent(String(requestParameters.service))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => ApiUrlSyncResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    onboardingServiceSignupAuthUrl(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.onboardingServiceSignupAuthUrlRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    onboardingServiceUpdateOnboardingRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.projectId === null || requestParameters.projectId === undefined) {
                throw new runtime.RequiredError('projectId', 'Required parameter requestParameters.projectId was null or undefined when calling onboardingServiceUpdateOnboarding.');
            }
            if (requestParameters.payload === null || requestParameters.payload === undefined) {
                throw new runtime.RequiredError('payload', 'Required parameter requestParameters.payload was null or undefined when calling onboardingServiceUpdateOnboarding.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            const response = yield this.request({
                path: `/services/onboarding/v1/projects/{projectId}`.replace(`{${"projectId"}}`, encodeURIComponent(String(requestParameters.projectId))),
                method: 'PATCH',
                headers: headerParameters,
                query: queryParameters,
                body: ApiSimpleOnboardingToJSON(requestParameters.payload),
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => ApiSimpleOnboardingFromJSON(jsonValue));
        });
    }
    /**
     */
    onboardingServiceUpdateOnboarding(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.onboardingServiceUpdateOnboardingRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
}
/**
    * @export
    * @enum {string}
    */
export var OnboardingServiceCreateOnboardingOnboardingTypeEnum;
(function (OnboardingServiceCreateOnboardingOnboardingTypeEnum) {
    OnboardingServiceCreateOnboardingOnboardingTypeEnum["ONBOARDING_TYPE_UNKNOWN"] = "OnboardingTypeUnknown";
    OnboardingServiceCreateOnboardingOnboardingTypeEnum["ONBOARDING_TYPE_WOO_COMMERCE"] = "OnboardingTypeWooCommerce";
    OnboardingServiceCreateOnboardingOnboardingTypeEnum["ONBOARDING_TYPE_SHOPIFY"] = "OnboardingTypeShopify";
})(OnboardingServiceCreateOnboardingOnboardingTypeEnum || (OnboardingServiceCreateOnboardingOnboardingTypeEnum = {}));
/**
    * @export
    * @enum {string}
    */
export var OnboardingServiceDeleteOnboardingOnboardingTypeEnum;
(function (OnboardingServiceDeleteOnboardingOnboardingTypeEnum) {
    OnboardingServiceDeleteOnboardingOnboardingTypeEnum["ONBOARDING_TYPE_UNKNOWN"] = "OnboardingTypeUnknown";
    OnboardingServiceDeleteOnboardingOnboardingTypeEnum["ONBOARDING_TYPE_WOO_COMMERCE"] = "OnboardingTypeWooCommerce";
    OnboardingServiceDeleteOnboardingOnboardingTypeEnum["ONBOARDING_TYPE_SHOPIFY"] = "OnboardingTypeShopify";
})(OnboardingServiceDeleteOnboardingOnboardingTypeEnum || (OnboardingServiceDeleteOnboardingOnboardingTypeEnum = {}));
/**
    * @export
    * @enum {string}
    */
export var OnboardingServicePublishOnboardingOnboardingTypeEnum;
(function (OnboardingServicePublishOnboardingOnboardingTypeEnum) {
    OnboardingServicePublishOnboardingOnboardingTypeEnum["ONBOARDING_TYPE_UNKNOWN"] = "OnboardingTypeUnknown";
    OnboardingServicePublishOnboardingOnboardingTypeEnum["ONBOARDING_TYPE_WOO_COMMERCE"] = "OnboardingTypeWooCommerce";
    OnboardingServicePublishOnboardingOnboardingTypeEnum["ONBOARDING_TYPE_SHOPIFY"] = "OnboardingTypeShopify";
})(OnboardingServicePublishOnboardingOnboardingTypeEnum || (OnboardingServicePublishOnboardingOnboardingTypeEnum = {}));
/**
    * @export
    * @enum {string}
    */
export var OnboardingServiceReadOnboardingOnboardingTypeEnum;
(function (OnboardingServiceReadOnboardingOnboardingTypeEnum) {
    OnboardingServiceReadOnboardingOnboardingTypeEnum["ONBOARDING_TYPE_UNKNOWN"] = "OnboardingTypeUnknown";
    OnboardingServiceReadOnboardingOnboardingTypeEnum["ONBOARDING_TYPE_WOO_COMMERCE"] = "OnboardingTypeWooCommerce";
    OnboardingServiceReadOnboardingOnboardingTypeEnum["ONBOARDING_TYPE_SHOPIFY"] = "OnboardingTypeShopify";
})(OnboardingServiceReadOnboardingOnboardingTypeEnum || (OnboardingServiceReadOnboardingOnboardingTypeEnum = {}));
/**
    * @export
    * @enum {string}
    */
export var OnboardingServiceSignupAuthServiceEnum;
(function (OnboardingServiceSignupAuthServiceEnum) {
    OnboardingServiceSignupAuthServiceEnum["SERVICE_UNSPECIFIED"] = "service_unspecified";
    OnboardingServiceSignupAuthServiceEnum["GOOGLE"] = "google";
    OnboardingServiceSignupAuthServiceEnum["BING"] = "bing";
    OnboardingServiceSignupAuthServiceEnum["FACEBOOK"] = "facebook";
    OnboardingServiceSignupAuthServiceEnum["ECWID"] = "ecwid";
    OnboardingServiceSignupAuthServiceEnum["SHOPIFY"] = "shopify";
    OnboardingServiceSignupAuthServiceEnum["WOOCOMMERCE"] = "woocommerce";
})(OnboardingServiceSignupAuthServiceEnum || (OnboardingServiceSignupAuthServiceEnum = {}));
/**
    * @export
    * @enum {string}
    */
export var OnboardingServiceSignupAuthUrlServiceEnum;
(function (OnboardingServiceSignupAuthUrlServiceEnum) {
    OnboardingServiceSignupAuthUrlServiceEnum["SERVICE_UNSPECIFIED"] = "service_unspecified";
    OnboardingServiceSignupAuthUrlServiceEnum["GOOGLE"] = "google";
    OnboardingServiceSignupAuthUrlServiceEnum["BING"] = "bing";
    OnboardingServiceSignupAuthUrlServiceEnum["FACEBOOK"] = "facebook";
    OnboardingServiceSignupAuthUrlServiceEnum["ECWID"] = "ecwid";
    OnboardingServiceSignupAuthUrlServiceEnum["SHOPIFY"] = "shopify";
    OnboardingServiceSignupAuthUrlServiceEnum["WOOCOMMERCE"] = "woocommerce";
})(OnboardingServiceSignupAuthUrlServiceEnum || (OnboardingServiceSignupAuthUrlServiceEnum = {}));
